// The section types a teacher can pick when adding a section (Custom Section
// and Blackboard Scan). One list so the two pickers can't drift apart — the
// Custom picker once lost "List". `id` is the backend `section_type`
// (custom_section_routes.py); the student renderer handles every one.
export const SECTION_TYPES = [
  { id: 'text', label: 'Text', hint: 'Plain paragraphs — explanations, stories, notes.' },
  { id: 'rich_text', label: 'Rich Text', hint: 'Formatted text with headings, bold, lists and tables.' },
  { id: 'cards', label: 'Cards', hint: 'Title + description cards — key terms, concepts, facts.' },
  { id: 'flashcards', label: 'Flashcards', hint: 'Question on the front, answer on the back — for revision.' },
  { id: 'problems', label: 'Problems', hint: 'Practice questions with hint, answer, difficulty and points.' },
  { id: 'list', label: 'List', hint: 'A resource list — videos, articles, books — each with an optional link.' },
  { id: 'visual', label: 'Visual', hint: 'Images and diagrams, with AI image prompts.' },
];

export const sectionTypeHint = (id) => SECTION_TYPES.find((t) => t.id === id)?.hint || '';

// Friendly name for a stored section type, e.g. 'blackboard_analysis' -> 'Blackboard analysis'.
export const sectionTypeLabel = (id) => {
  const known = SECTION_TYPES.find((t) => t.id === id);
  if (known) return known.label;
  const words = String(id || 'text').replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};
